import { createReducer } from 'utils'
import { fromJS } from 'immutable'

import { constants } from 'common/actions/user'
import { RESET_ERROR } from 'common/actions/error'

export const initialState = fromJS({
  isSubmitting: false,
  error: null
})

export default createReducer(initialState, {
  [RESET_ERROR]: state => state.set('error', null),

  [constants.SEND_USER_OCCURRENCE_REQUEST.START]: state => state.set('isSubmitting', true),
  [constants.SEND_USER_OCCURRENCE_REQUEST.SUCCESS]: () => initialState,
  [constants.SEND_USER_OCCURRENCE_REQUEST.FAILURE]: (state, { payload: error }) => {
    return state.set('isSubmitting', false).set('error', error)
  }
})
